export const initialBreakpoints = {
    mobile: false,
    tablet: false,
    touch: false,
    desktop: false,
    highDefinition: false,
    widescreen: false,
    fullhd: false,
};
